var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view',{on:{"show-alert":_vm.showAlert}})],1),_c('alert-snackbar',{ref:"alert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }